export default function IconDone(props: Icon) {
  const { height, width, className } = props;
  return (
    <svg
      className={className}
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 16}
      height={height ? height : width ? width : 16}
      viewBox="0 -960 960 960"
    >
      <path
        fill="currentColor"
        d="M382-208 122-468l90-90 170 170 366-366 90 90-456 456Z"
      />
    </svg>
  );
}
